<template>
     <div class="absolute top-0 z-50  w-full h-full flex items-center justify-center">
        <div class=" w-full h-full bg-gray-500 blur-lg opacity-70">
            <div class=" orderPanel  absolute flex flex-col m-auto w-10/12 md:w-4/5 md:max-w-md rounded bg-slate-200">
                <div>
                    <div class="flex border-b border-blue-400 p-2 ">
                        <div class="ml-auto font-bold text-xl">Printing</div>
                        <div v-on:click="close()" class=" ml-auto w-8 h-8 bg-slate-100 border-slate-300 rounded-full flex active:scale-75 hover:scale-105">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class=" w-7 h-7 m-auto">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
</template>

<script>
export default{
    data(){
        return{
            BalanceEntry:null,
            order:[
                    {
                        Quantity:2,
                        Description:"Home Router",
                        Price: 250
                    }
                ],

            Customer:null,
            ServedBy: 'Yolamu',
            SubPeriod_start: null,
            SubPeriod_end: null,
            PrintDate: new Date().toLocaleDateString(),
            PhoneNumber: "+260964948025",

            Currency:"K",
            CompanyName:"PACKYMS TECHNOLOGY",
            projectName:"Unlimited Community Internet",
                

        }
    },
    methods:{
        printData(){
            this.Customer = this.$parent.selectedBalanceEntry.username;
            const order = [
                {
                    Quantity: 1,
                    Description:this.$parent.selectedBalanceEntry.entry_details,
                    Price: this.$parent.selectedBalanceEntry.entry_amount*-1,
                    EntryDate: this.$parent.selectedBalanceEntry.created_at
                }
            ];
            var totalPrice = 0;
    
            const starthtml = '<html>'                                    
    
            const stylehtml = '<head>'+
                                '<style>'+
                                    '* {'+
                                        'font-size: 12px;'+
                                        'font-family: \'Times New Roman\';'+
                                        '}'+
                                    'td,'+
                                    'th,'+
                                    'tr,'+
                                    'table {'+
                                        'width: 100%;'+
                                        'text-align-last: center;'+
                                        'border-top: 1px solid black;'+
                                        'border-collapse: collapse;'+
                                        '}'+
                                    'td.description,'+
                                    'th.description {'+
                                    'width: 75px;'+
                                    'max-width: 75px;'+
                                    '}'+
                                    'td.quantity,'+
                                    'th.quantity {'+
                                        'width: 40px;'+
                                        'max-width: 40px;'+
                                        'word-break: break-all;'+
                                    '}'+
                                    'td.price,'+
                                    'th.price {'+
                                        'width: 40px;'+
                                        'max-width: 40px;'+
                                        'word-break: break-all;'+
                                    '}'+
                                    '.centered {'+
                                        'text-align: center;'+
                                        'align-content: center;'+
                                    '}'+
                                    '.ticket {'+
                                        'width: 95%;'+
                                        'margin-left: auto;'+
                                        '/*max-width: 500px;*/'+
                                    '}'+
                                    'img {'+
                                        'max-width: inherit;'+
                                        'width: inherit;'+
                                    '}'+
                                    '.receiptTitleText {'+
                                    'font-size: 16px;'+
                                    'margin-top: 1.2rem;'+
                                    'margin-bottom: 1.1rem;'+
                                    '}'+
                                    '.companyname {'+
                                    'font-size: 20px;'+
                                    '}'+
                                    '.projectname {'+
                                    'font-size: 15px;'+
                                    '}'+
                                    '.Customername {'+
                                    'font-size: 17px;'+
                                    'margin-top: 1.2rem;'+
                                    'margin-bottom: 1.2rem;'+
                                    '}'+
                                    '.SubPeriod {'+
                                    'font-size: 12px;'+
                                    'margin-top: 1.2rem;'+
                                    'margin-bottom: 1.1rem;'+
                                    '}'+
                                    '.ServedBy {'+
                                    'font-size: 12px;'+
                                    'margin-top: 1.2rem;'+
                                    '}'+
                                    '.SignedBy {'+
                                    'font-size: 12px;'+
                                    'margin-top: 1.2rem;'+
                                    '}'+
                                    '.DateText {'+
                                    'font-size: 12px;'+
                                    'margin-top: 1.2rem;'+
                                    '}'+
                                    '.titleBlock{'+
                                        'display: flex;'+
                                    '}'+
                                 '</style>'+
                                '</head>'
    
            const midhtml1 = '<body>'+
                                '<div class="ticket">'+
                                    '<h1 class="centered receiptTitleText">Customer Receipt</h1>'+
                                 '<!--<img class="img" src="./assets/logo.png" alt="Logo">-->'
    
            const midhtml2 = '<div class="">'+
                                '<div>'+
                                    '<h1 class="centered companyname">'+this.CompanyName+'</h1>'+
                                    '<h1 class="centered projectname">'+this.projectName+'</h1>'+
                                '</div>'+
                            '</div>'
    
            const midhtml3 = '<div class="">'+
                                '<div>'+
                                    '<div class=" Customername">Customer: '+this.Customer+'</div>'+
                                    // '<div class=" SubPeriod">Subscription: '+this.SubPeriod_start+ ' - '+this.SubPeriod_end+ '</div>'+
                                '</div>'+
                            '</div>'
    
            const topTableRow = '<table> '+
                                    '<thead> '+
                                        '<tr > '+
                                            '<th class="quantity">Quantity.</th> '+
                                            '<th class="description">Description</th>'+
                                            '<th class="price">Amount</th> '+
                                        ' </tr> '+
                                    '</thead> '+
                                    '<tbody>'
            var orderList = ''
            console.log(order)
            for (let index = 0; index < order.length; index++) {
                const orderitem = order[index];
                var orderitemHtml = '<tr>'
    
                
                    orderitemHtml = orderitemHtml+ '<td class="quantity">'+orderitem.Quantity+'</td>'
                    orderitemHtml = orderitemHtml+ '<td class="description">'+orderitem.Description+'</td>'
                    orderitemHtml = orderitemHtml + '<td class="price">'+this.Currency+(orderitem.Price*orderitem.Quantity)+'</td>'
                    orderitemHtml = orderitemHtml+ '</tr>'
                    totalPrice = totalPrice+(orderitem.Price*orderitem.Quantity)
                    orderList = orderList+orderitemHtml
            }                            
            
            
            const bottomTableRow = '<tr class="tr">'+
                                    '</tr>'+
                                    '<tr class="tr">'+
                                    '<td class="quantity"></td> '+
                                    '<td class="description">TOTAL</td>'+
                                    '<td class="price">'+this.Currency+ totalPrice+'</td>'+
                                    '</tr>'+
                                    '</tbody>'+
                                    '</table>'
    
            const signer = '<div class="">'+
                                '<div>'+
                                    '<div class=" ServedBy"> Served BY: '+this.ServedBy+'</div>'+
                                    // '<div class=" SignedBy"> Signature: '+'</div>'+
                                    '<div class=" DateText"> Payment Entry Date: '+this.$parent.convertDate(this.$parent.selectedBalanceEntry.created_at)+'</div>'+
                                    // '<div class=" DateText"> Payment Entry Date: '+this.PrintDate+'</div>'+
                                '</div>'+
                            '</div>'
    
            const endhtml = '</div>'+
                            '</body>'+
                            '</html>'
            // eslint-disable-next-line no-undef
            // cordova.plugins.printer.print(starthtml+stylehtml+midhtml1+midhtml2+midhtml3+topTableRow+orderList+bottomTableRow+signer+endhtml);       
            // Open the print window
            const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

            
            WinPrint.document.write(starthtml+stylehtml+midhtml1+midhtml2+midhtml3+topTableRow+orderList+bottomTableRow+signer+endhtml);       
        
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
            WinPrint.close();

            this.close();
        },
        close(){
          this.$parent.ShowPrintPage(false);
        }
    },
    mounted(){
    this.printData()
  }
}

</script>

<style scoped>
.orderPanel{
max-height: 85%;
}
</style>
